import React from 'react';

import './PartnersCards.scss';

import { PartnerCard } from '../../';

class PartnersCards extends React.PureComponent {
    renderPartners = () => {
        const partners = this.props.partners.list;

        return partners.map((partner, index) => {
            return <PartnerCard key={index} partner={partner}/>
        })
    };

    render() {

        return (
            <section className="partnersCards">
                <div className="container">
                    <h6 className="text-center">{this.props.partners.title}</h6>
                    <div className="row">
                        {this.renderPartners()}
                    </div>
                </div>
            </section>
        );

    }
}

export default PartnersCards;


// WEBPACK FOOTER //
// ./src/components/Partners/PartnersCards/PartnersCards.js